import {ICameraFactory} from './camera.provider'
import {WebcamUtil} from 'ngx-webcam'

export class CameraFactory implements ICameraFactory {
  getAvailableVideoInputs(): Promise<MediaDeviceInfo[]> {
    return WebcamUtil.getAvailableVideoInputs()
  }
}